import { render } from "./Settings.vue?vue&type=template&id=72446f4c&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "@/assets/scss/_settings.scss?vue&type=style&index=0&id=72446f4c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72446f4c"]])

export default __exports__